module.exports = __webpack_public_path__ + "static/media/Screenshot_6-thumb.34d5fa03.png";